<template>
  <aside class="side-menu">
    <h3>Administrador</h3>
    <ul>
      <li>
        <router-link to="/Admin/Home">
          <i class="bi bi-house-fill icon"></i> Inicio
        </router-link>
      </li>
      <li>
        <router-link to="/Admin/reservaciones">
          <i class="bi bi-calendar-check icon"></i> Reservaciones
        </router-link>
      </li>
      <li>
        <router-link to="/Admin/conductores">
          <i class="bi bi-people icon"></i> Conductores
        </router-link>
      </li>
      <li>
        <router-link to="/Admin/usuarios">
          <i class="bi bi-person icon"></i> Usuarios
        </router-link>
      </li>
      <li>
        <router-link to="/Admin/Autos">
          <i class="bi bi-car-front icon"></i> Autos
        </router-link>
      </li>
      
      <li>
        <router-link to="/Admin/pago">
          <i class="bi bi-cash-coin icon"></i> Pago
        </router-link>
      </li>
      <li>
        <router-link to="/Admin/tarifa">
          <i class="bi bi-geo-alt icon"></i> Tarifas
        </router-link>
      </li>
        <li>
        <router-link to="/Admin/ubicaciones">
          <i class="bi bi-car-front"></i><i class="bi bi-geo"></i>  Ubicaciones
        </router-link>
      </li>
      <li>
        <router-link to="/Admin/Reporte">
          <i class="bi bi-file-earmark-spreadsheet icon"></i>  Reportes
        </router-link>
      </li>
      <li>
        <router-link to="/Admin/banco">
          <i class="bi bi-credit-card-2-front-fill icon"></i> Datos banco
        </router-link>
      </li>
      <li>
        <router-link to="/Admin/parametros">
          <i class="bi bi-gear icon"></i> Parametros
        </router-link>
      </li>
    </ul>
  </aside>
</template>

<script>
export default {
  name: "MenuSide",
};
</script>

<style scoped>
.side-menu {
  width: 200px;
  background-color: rgb(61, 61, 61);
  color: white;
  padding-top: 20px;
  height: 100vh;
  position: fixed;
  left: 0;
}

.side-menu h3 {
  text-align: center;
  margin: 0;
  padding: 10px 0;
}

.side-menu ul {
  list-style: none;
  padding: 0;
}

.side-menu li {
  padding: 10px;
}

.side-menu li a {
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
}

.side-menu li a:hover {
  background-color: #495057;
  border-radius: 4px;
}

/* Añade un margen a la derecha de los íconos */
.icon {
  margin-right: 8px; /* Ajusta el valor según la separación que desees */
}
</style>
